export enum EUnitPeriod {
  minute = 'minute',
  hour = 'hour',
  day = 'day',
  week = 'week',
  month = 'month',
  year = 'year',
}

export enum ERoleType {
  'global' = 1,
  'organization' = 2,
  'office' = 3,
}
